import { h } from 'preact';
import fm from '@os/finance-model';
import { provide } from 'preact-context-provider';

// we'll hand out a single shared instance
let financeModel = fm();

/**
 * Wrap any component wtih a Provider (@see preact-context-provider) that supplies the financeModel
 *
 * @param Child {Component} A Component to be wrapped
 * @return {Component} A component that wraps Child in <Provider financeModel={financeModelInstance}>
 *
 * @example
 * import provideFinanceModel from '../provide-finance-model';
 * const MyWidget = (props) => <div {...props />
 * export default provideFinanceModel(MyWidget);
 *
 */
export default provide({ financeModel });
